export default __webpack_public_path__ + "media/ddd5ad81ad30c1130154b59732d647fc22eaf231a06965cce9df2ac57dae5228.svg";